import { Button } from '@ordr-as/umami-react/button';
import type { MenuSubSectionDto } from '../../../../generated-api';
import classNames from 'clsx';
import { useCallback } from 'react';

interface SubsectionsHeaderProps {
  subsections: MenuSubSectionDto[];
  onSubsectionSelected: (sectionId?: string) => void;
  selectedSubsectionId?: string;
  overflowRef?: React.RefObject<HTMLDivElement>;
  isExpanded?: boolean;
}

const SubsectionHeader = ({
  subsections,
  onSubsectionSelected,
  selectedSubsectionId,
  overflowRef,
  isExpanded,
}: SubsectionsHeaderProps) => {
  const handleSubsectionClick = useCallback(
    (menuSectionId?: string) => {
      onSubsectionSelected(menuSectionId);
    },
    [onSubsectionSelected]
  );

  const wrapperClassName = classNames('flex gap-2 tablet:pb-4', {
    'flex-wrap overflow-visible pr-7': isExpanded,
    'overflow-x-auto flex-nowrap': !isExpanded,
  });

  const baseStyling = 'flex flex-shrink-0 px-4 items-center rounded-full text-sm cursor-pointer';

  const selectedSectionStyling = 'bg-purple-lightest border border-brand-primary text-brand-primary font-semibold';
  const notSelectedSectionStyling =
    'bg-brand-white text-grey-dark hover:border hover:border-brand-primary hover:text-brand-primary';

  return (
    <div ref={overflowRef} className={wrapperClassName}>
      <Button
        key="1234"
        height={36}
        onClick={() => handleSubsectionClick(undefined)}
        className={`${baseStyling} ${selectedSubsectionId ? notSelectedSectionStyling : selectedSectionStyling}`}
      >
        All products
      </Button>
      {subsections.map((subsection) => (
        <Button
          key={subsection.id}
          height={36}
          onClick={() => handleSubsectionClick(subsection.id)}
          className={`${baseStyling} ${
            subsection.id === selectedSubsectionId ? selectedSectionStyling : notSelectedSectionStyling
          }`}
        >
          {subsection.name}
        </Button>
      ))}
    </div>
  );
};
export default SubsectionHeader;
